import { createContext } from "react";

// Global toggle: share/private switches only mount in "Sichtbarkeit
// bearbeiten" mode; otherwise they'd overload the view.
export const ShareEditContext = createContext<{ mounted: boolean; exiting: boolean }>({
  mounted: false,
  exiting: false,
});

// Edit-ability of the view. Always true in pilot (own profile only -
// viewingOther mode deferred to Phase 5).
export const EditContext = createContext<boolean>(true);

// Flipped by a save the editor blocked, so every offending field reveals its
// warning at once instead of only the one the user last left. The editor-side
// twin of the merge store's `revealDateErrors`; both feed `useFieldWarning`.
export const ProfileRevealContext = createContext<boolean>(false);
